export default function EmailError(message) {
	if (typeof message !== "string") {
		message = message.toString();
	}
	const url = window.location.href;
	$.post('/a/log/', {
		url: url,
		error: message
	});
};